import Delegate from 'ftdomdelegate';

import Animation from '../tools/animation';

(function () {
  var documentDelegate = new Delegate(document.body);

  documentDelegate.on(
    'click',
    '.expandableContent__toggle',
    function (item, expandableButton) {
      var parentSection = expandableButton.closest('.expandableContent');

      if (parentSection.getAttribute('aria-expanded') === 'true') {
        // Previously expanded, so we have to close it
        parentSection.style.height = parentSection.offsetHeight + 'px';
        parentSection.offsetHeight; // Use to force a redraw
        parentSection.style['height'] = null; // Remove the attribute to let the CSS decide the height
        parentSection.setAttribute('aria-expanded', 'false');

        var expandableText = expandableButton.querySelector(
          '.expandableContent__toggleText'
        );
        expandableText.innerHTML =
          expandableText.getAttribute('data-view-more');
      } else {
        // Because the expandable button is still positioned absolutely, we need to add margin to the sibling
        // text to account the button. It's a bit ugly and hacky but this was the simplest I've found
        if (expandableButton.previousElementSibling) {
          expandableButton.previousElementSibling.style['margin-bottom'] =
            parseInt(expandableButton.clientHeight) + 'px';
        }

        Animation.slideDown(parentSection, function () {
          // Previously collapsed, so we have to open it
          parentSection.setAttribute('aria-expanded', 'true');
        });
        var _expandableText = expandableButton.querySelector(
          '.expandableContent__toggleText'
        );
        _expandableText.innerHTML =
          _expandableText.getAttribute('data-view-less');
      }
    }
  );

  var processCollapsibles = function processCollapsibles() {
    document
      .querySelectorAll('.expandableContent[aria-expanded]')
      .forEach(function (item) {
        if (item.scrollHeight > item.clientHeight) {
          item.classList.add('expandableContent--expandable');
        } else {
          item.setAttribute('aria-expanded', 'true');
        }
      });
  };

  document.addEventListener('shopify:section:load', function (event) {
    processCollapsibles();
  });

  processCollapsibles();
})();
